import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { lighten } from 'polished';
import theme from '../../styles/theme';

export const NavBarWrapper = styled.header`
  position: fixed;
  width: 100%;
  background-color: ${props => (props.useDarkBackground ? `${theme.navbar.dark}` : `${theme.navbar.light}`)};
  top: 0;
  left: 0;
  border-bottom: 1px solid ${props => (props.useDarkBackground ? `${theme.navbar.dark}` : `${theme.borderColor.grayBorder}`)};
  padding: 0.687rem 0px;
  z-index: 99;
  display: ${props => (props.mobile ? 'block' : 'none')};

  ul {
    list-style: none;
    padding: 0;
    margin: auto;
  }

  li {
    margin-bottom: 0;
    display: inline-block;
    color: white;
  }

  @media (min-width: 990px) {
    display: ${props => (props.mobile ? 'none' : 'block')};

    li {
      color: ${props => (props.useDarkBackground ? `${theme.body.dark}` : `${theme.body.light}`)};
    }
  }
`;
NavBarWrapper.defaultProps = {
  useDarkBackground: false,
};
NavBarWrapper.defaultProps = {
  useDarkBackground: PropTypes.bool,
};

export const PromotionBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  margin-top: -0.687rem;
  margin-bottom: 8px;
  background-color: #2C3346;
  color: white;
  text-transform: uppercase;

  & > *:not(:last-child)::after {
    content: '•';
    color: white;
    margin: 0 5px;
  }

  a {
    text-decoration: underline;
    text-decoration-line: underline;
    text-underline-offset: 4px;
    text-decoration-thickness: 1px;
  }

  @media (max-width: 767px) {
    .hide-xs {
      display: none;
    }
  }
`;

export const Badge = styled.span`
  display: inline-block;
  background-color: #2BCA86;
  color: white;
  padding: 1px 6px;
  border-radius: 15px;
`;

export const NavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  
  @media (min-width: 990px) {
    position: relative;
  }
`;

export const NavBrand = styled.div`
  font-weight: 400;
  font-size: 1.25rem;
  color: ${props => (props.useDarkBackground || props.isOpen ? `${theme.body.dark}` : `${theme.textColor.darkGrayText}`)};
  margin: auto 0 auto 0;
  width: 350px;
  z-index: 4;
  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    font-size: 1rem;
    line-height: 1.2rem;
    white-space: nowrap;
  }

  a:nth-child(2) {
    opacity: ${props => (props.searchOpen ? '0' : '1')};
  }

  b {
    font-weight: 700;
    opacity: ${props => (props.searchOpen ? '0' : '1')};
  }

  img {
    margin: 0 1.187rem 0 0;
    width: 1.875rem;
    max-width: initial;
  }
  @media (min-width: 768px) {
    opacity: 1;
  }
  @media (min-width: 1200px) {
    width: 400px;
  }
`;
NavBrand.defaultProps = {
  useDarkBackground: false,
  isOpen: false,
  searchOpen: false,
};
NavBrand.defaultProps = {
  useDarkBackground: PropTypes.bool,
  isOpen: PropTypes.bool,
  searchOpen: PropTypes.bool,
};


export const NavControls = styled.div`
  margin-left: auto;
  margin-right: 0;
  display: flex;
  width: 400px;

  ul {
    display: flex;
    margin-right: 0;
  }

  li {
    display: flex;
    font-size: 0.875rem;
    line-height: 1.05rem;
  }

  li:not(:last-child) {
    margin: 0 0.8rem 0 0;
  }
  @media (max-width: 1199px) {
    width: 350px;
  }
  @media(max-width: 989px) {
    width: 200px;

    button {
      margin-right: 0;
      margin-left: auto;
      outline: none;
    }

    ul {
      margin-left: 0;
    }
  }
`;

export const NavLinkExternal = styled.a`
  padding: 0.66rem 0.5rem 0.66rem 0;
  display: inline-block;
  white-space: nowrap;
  color: inherit;
  font-weight: 400;
  font-size: 0.875rem;
  letter-spacing: 1;
  line-height: 1.05rem;

  &:hover,
  &.active {
    color: ${theme.hover.hoverBlue};
    font-weight: 700;
    letter-spacing: -0.1px;
    background-color: ${lighten(0.3, theme.hover.hoverBlue)};
    border-radius: 3px;
  }
  &.use-dark-mode {
    color: ${theme.body.dark};
    background-color: inherit;
  }
  
  @media (min-width: 990px) {
    padding: 0.66rem 0.5rem;
  }
`;

export const NavLink = styled(Link)`
  padding: 0.66rem 0.5rem 0.66rem 0;
  display: inline-block;
  white-space: nowrap;
  color: inherit;
  font-weight: 400;
  font-size: 0.875rem;
  letter-spacing: 1;
  line-height: 1.05rem;

  &:hover,
  &.active {
    color: ${theme.hover.hoverBlue};
    font-weight: 700;
    letter-spacing: -0.1px;
    background-color: ${lighten(0.3, theme.hover.hoverBlue)};
    border-radius: 3px;
  }
  &.use-dark-mode {
    color: ${theme.body.dark};
    background-color: inherit;
  }

  @media (min-width: 990px) {
    padding: 0.66rem 0.5rem;
  }
`;


export const Spacer = styled.span`
  margin: 0 0.8rem;
`;

export const Progress = styled.div`
  position: absolute;
  bottom: 0;
  background: linear-gradient(
    to right,
    ${theme.background.blue} ${props => props.scrollPercentage},
    transparent 0
  );
  width: 100%;
  height: 4px;
  z-index: 3;
`;
Progress.defaultProps = {
  scrollPercentage: '0%',
};
Progress.propTypes = {
  scrollPercentage: PropTypes.string,
};
